import { useState } from "react";
import { CreatePaymentMethodModel } from "@core/model/query-model-payment-method";
import { useQyCreatePaymentMethod, useQyGetPaymentMethod } from "@core/query/payment-method.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export const useFormDropdownPaymentMethod = () => {
  const { showWarning, showSuccess } = useNotificationContext();
  const [sidebar, setSidebar] = useState(false);
  const [filter, setFilter] = useState("");
  const [newPaymentMethod, setNewPaymentMethod] = useState<CreatePaymentMethodModel>({
    name: "",
    description: "",
  });
  const [isCreating, setIsCreating] = useState(false);

  const handleFilterInput = (event: any) => {
    if (event.key === "Enter") {
      setNewPaymentMethod({
        name: filter,
        description: "",
      });
      setSidebar(true);
    }
  };
  const handleAdd = () => {
    if (!newPaymentMethod.name) {
      showWarning("Please fill in PaymentMethod details");
      return;
    }
    setIsCreating(true);
    addPaymentMethod(newPaymentMethod);
  };

  const handleAddApiSuccess = () => {
    showSuccess(
      "New PaymentMethod is added. Check and select the PaymentMethod in the form."
    );
    setSidebar(false);
    setIsCreating(false);
  };
  const handleAddApiError = () => {
    setIsCreating(false);
  };
  const { mutate: addPaymentMethod } = useQyCreatePaymentMethod(
    handleAddApiSuccess,
    handleAddApiError
  );
  const { data: paymentMethodResponse } = useQyGetPaymentMethod('');
  const mappedPaymentMethod = (paymentMethodResponse?.data || []).map(
    (item) =>
      ({
        label: item.name,
        value: item.code,
      } as LabelValue)
  );

  return {
    sidebar,
    filter,
    newPaymentMethod,
    mappedPaymentMethod,
    isCreating,
    paymentMethodResponse,
    setSidebar,
    setFilter,
    setNewPaymentMethod,
    handleFilterInput,
    handleAdd,
    addPaymentMethod,
  };
};